import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'common/Links'

export default function ModalNoLicense({ show, onHide }) {
	const { t } = useTranslation('account')

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				<Modal.Title>{t('license_manager.modal_no_license.title')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className="text-muted">{t('license_manager.modal_no_license.description')}</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="dark" onClick={onHide}>
					{t('license_manager.cancel')}
				</Button>
				<Button as={Link} to="/" variant="primary">
					{t('license_manager.modal_no_license.to_shop')}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
